import { Injectable } from '@angular/core';

import { CanActivateChild, Router } from '@angular/router';

import { AdminConfigService } from '@app/core/admin-config.service';

@Injectable({
  providedIn: 'root'
})
export class AdminConfigGuard implements CanActivateChild {
  constructor(private router: Router, private $config: AdminConfigService) {}

  async canActivateChild(): Promise<boolean> {
    const tables = this.$config.getTables();
    if (!tables || tables.length === 0) {
      this.router.navigateByUrl('/');
      return false;
    }

    return true;
  }
}
